module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.enableMicrosoft) ? _c('a', {
    staticClass: "social-button microsoft-button column is-5-fullhd is-5-tablet is-12-mobile"
  }, [_c('MicrosoftWhite'), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Login with Microsoft")])], 1) : _vm._e(), _vm._v(" "), (_vm.enableGoogle) ? _c('a', {
    staticClass: "social-button google-button column is-5-fullhd is-5-tablet is-12-mobile",
    attrs: {
      "href": _vm.GoogleURL
    }
  }, [_c('GoogleColor'), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Login with Google")])], 1) : _vm._e(), _vm._v(" "), (_vm.enableClever) ? _c('a', {
    staticClass: "social-button clever-button column is-5-fullhd is-5-tablet is-12-mobile"
  }, [_c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Login with Clever")])]) : _vm._e(), _vm._v(" "), (_vm.nonFieldErrors) ? _c('FormErrors', {
    attrs: {
      "errors": _vm.nonFieldErrors
    }
  }) : _vm._e(), _vm._v(" "), (_vm.emailErrors) ? _c('FormErrors', {
    attrs: {
      "errors": _vm.emailErrors
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-3bda5c82"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialButtons.vue
// module id = 1010
// module chunks = 0